import { useNavigate } from "react-router-dom";

import { CustomButton, Text } from "../shared/uiComponents";
import Wrapper from "../components/WrapperWithoutMenu";
import { CheckboxWrapper } from "../components/StyledComponents";

const Component = () => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return (
    <CheckboxWrapper>
      <Text
        title="Page not found"
        size="largeBold"
        className="marginBottom24"
      />
      <CustomButton title="Go back" onClick={goBack} />
    </CheckboxWrapper>
  );
};

const NotFound = () => {
  return <Wrapper Component={Component} />;
};

export default NotFound;
